import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navber from './Components/Header/Navbar'
import Hompage from './Components/Homepages/Hompage';
import { createContext } from 'react';
import axios from 'axios';
import FooterNew from './Components/Homepages/Footer';
import CompanyOverview from './Components/About';
import AboutUs from './Components/About';
import InfoSection from './Components/Contact';
import ServiceSection from './Components/Service';
import './App.scss';
import Products from './Components/Elevators';
import Projects from './Components/Homepages/Projects';
import Elevator from './Components/Elevator';
import Gallary from './Components/Homepages/Gallary';
import GallaryTwo from './Components/Homepages/GallaryTwo';
import MyCarouselbootstrap from './Carojesbootstrap';
import Escalator from './Components/Escalator';
import Career from './Components/Career';
import TermsAndConditions from './Components/terms';
import PrivacyPolicy from './Components/privacy';




export const store = createContext()
function App() {
  const [menus, setMenus] = useState(
    {
      "items": [
        {
          "label": "Home",
          "url": "/"
        },
        {
          "label": "About Us",
          "url": "about"
        },
        {
          "label": "Products",
          "url": "/products",
          "submenu": [
            { "label": "Elevators", "url": "/elevators" },
            { "label": "Escalators & Travelators", "url": "/escalators" },

          ]
        },
        {
          "label": "Projects",
          "url": "/projects"
        },
        {
          "label": "Services",
          "url": "/services"
        },

        {
          "label": "Gallery",
          "url": "/gallary"
        },
        {
          "label": "Contact",
          "url": "/contact"
        }

      ]
    }

  );
  const [isOpen, setIsOpen] = useState(false);
  const [navbarclose, setNavbarClose] = useState("navbar-open")



  return (
    <>

      <store.Provider value={[menus, setMenus, isOpen, setIsOpen, navbarclose, setNavbarClose]}>
        <BrowserRouter>
          <Navber />
          <Routes>
            <Route path="/" element={<Hompage />} />
            <Route path='/about-us' element={<AboutUs />} />
            <Route path='/contact-us' element={<InfoSection />} />
            <Route path='/services' element={<ServiceSection />} />
            <Route path="/elevators" element={<Products />} />
            <Route path="/escalators-and-travelators" element={<Escalator />} />
            {/* <Route path='/gallary' element={<Gallary/>} /> */}
            <Route path='/gallery' element={<GallaryTwo />} />
            <Route path='/projects' element={<Projects />} />
            <Route path='/elevators/:subcoomponent' element={<Elevator />} />
            <Route path='/escalators/:subcoomponent' element={<Escalator />} />
            <Route path='/careers' element={<Career/>}/>
             <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={< PrivacyPolicy/>} />
          </Routes>
        </BrowserRouter>
      </store.Provider>

    </>

  );
}

export default App;
